import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Box } from '@mui/material';
import { K8S_VULNERABILITIES_SUB_TABS, k8sVulnerabilitiesSubTabPath } from '@root/constants/moduleTabs';
import CVE from './CVEs';
import Findings from './Findings';
import Images from './Images';
import VulnerabilitySubTabs from './VulnerabilitySubTabs';
import Workload from './workload';

const pages = {
  findings: Findings,
  cves: CVE,
  workloads: Workload,
  images: Images,
};

// Sub tabs that render the spotlight themselves (passed as `riskSpotlight`), below their filter card.
const SUB_TABS_PLACING_RISK_SPOTLIGHT = ['findings', 'cves'];

/**
 * The Vulnerabilities tab: the sub tab strip, then the selected sub tab. The page shell resolves
 * `subTab` from the URL, so a sub tab change is just a navigation.
 */
const VulnerabilitiesTab = ({ subTab, isEnabled, riskSpotlight }) => {
  const history = useHistory();
  const Page = pages[subTab];

  const handleSubTabChange = useCallback(tab => history.push(k8sVulnerabilitiesSubTabPath(tab)), [history]);

  return (
    <>
      <Box px="15px" pt="15px">
        <VulnerabilitySubTabs
          tabs={K8S_VULNERABILITIES_SUB_TABS.tabs}
          selectedTab={subTab}
          onChange={handleSubTabChange}
        />
      </Box>
      {!SUB_TABS_PLACING_RISK_SPOTLIGHT.includes(subTab) && riskSpotlight}
      <Page isEnabled={isEnabled} riskSpotlight={riskSpotlight} />
    </>
  );
};

export default VulnerabilitiesTab;
